import AxiosAPI from '../../utils/AxiosAPI';

export const handleGetReportOpe = (category, type, q) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/reports/${category}/${type}`, { ...q })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

export default null;
